import { i18n } from "../../../translate/i18n.js";

import { LoadingContent } from "../../../components/SharedComponents/sharedComponents.index.jsx";
import { LOADING_CONTENT_TYPE } from "../../../components/SharedComponents/LoadingContent/loading.content.constants.js";

import { Default } from "../../../components/Default/Default.jsx";

import { ProductView } from "./ProductView/ProductView.jsx"

import { useAnalysisViewModel } from "../../../viewModel/useAnalysysViewModel.js";

export function PlanVsForecast() {

  const { t } = i18n;

  const vm = useAnalysisViewModel({
    shouldFetchConsolidatedIndexes: true,
    shouldFetchProducts: true,
    shouldFetchConsolidatedPredictions: true,
    shouldFetchForecastData: true,
    shouldFetchFiltersAndDriversOptions: true
  });

  if (vm.uiState.isLoadingForecast || vm.uiState.isLoadingProducts || vm?.uiState?.isLoadingIndexes || vm?.uiState?.isLoadingConsolidatedPredictions) {
    return (
      <LoadingContent label={t("dataProcessing")} type={LOADING_CONTENT_TYPE.API_PAGE_DATA} mode={LOADING_CONTENT_TYPE.API_PAGE_DATA}/>
    )
  }
  
  return (
    <Default>
      <div style={{ display: "flex", flexDirection: "row", inlineSize: "100%", overflowX: "auto", padding: "0 0 0 1rem" }}>

        <ProductView
          actions={{ 
            setSelectedProductIds: vm.actions.setSelectedProductIds,
            setFreezeColumns: vm.actions.setFreezeColumns
          }}          
          ctx={{ 
            products: vm?.ctx?.products,
            productIds: vm.ctx.productIds, 
            selectedProductIds: vm.ctx.selectedProductIds,
            generationDate: vm?.ctx.generationDate,
          }}
          uiState={{ freezeColumns: vm.uiState.freezeColumns }}/>
      </div>
    </Default>
  );
}